import { makeObservable, observable } from "mobx";

export interface IFeatures {
  manageClients: boolean;
  manageCameraViewSettings: boolean;
  showLastLocation: boolean;
  isVoiceAlertAvailable: boolean;
  manageAccessSettings: boolean;
  manageMaris: boolean;
  managePeripherals: boolean;
  showTriggerPort: boolean;
  canTriggerNursePresence: boolean;
  enableApiAuthorization: boolean;
  initialConfigCompleted: boolean;
  isInactivityAlertAvailable: boolean;
  mariAddButtonEnabled: boolean;
  mariDeleteButtonAvailable: boolean;
  mariUniteIdColumnVisible: boolean;
  onlyVirtualSensorAvailable: boolean;
  showUnmappedSensorsToNurseAdmins: boolean;
  staleDataMessageVisible: boolean;
}

export default class FeatureStore {
  constructor() {
    makeObservable(this, {
        featureList: observable,
    });
  }

  public featureList: IFeatures = {
    manageClients: true,
    manageCameraViewSettings: true,
    showLastLocation: true,
    isVoiceAlertAvailable: true,
    manageAccessSettings: true,
    manageMaris: true,
    managePeripherals: true,
    showTriggerPort: true,
    canTriggerNursePresence: true,
    enableApiAuthorization: true,
    initialConfigCompleted: true,
    isInactivityAlertAvailable: true,
    mariAddButtonEnabled: true,
    mariDeleteButtonAvailable: true,
    mariUniteIdColumnVisible: true,
    onlyVirtualSensorAvailable: true,
    showUnmappedSensorsToNurseAdmins: true,
    staleDataMessageVisible: true,
  };
}
